import React from 'react';
import { Loader } from 'semantic-ui-react';

const LoadingSuspense: React.FC = () => {
  return (
    <div className="loading_suspense">
      <Loader size="large" active />
    </div>
  );
};

export default LoadingSuspense;
